import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import type { DashboardStats } from './homeTypes'

export function useDashboardStats(dateFrom: Date, dateTo: Date) {
  return useQuery({
    queryKey: ['dashboard-stats', dateFrom.toISOString(), dateTo.toISOString()],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_dashboard_stats', {
        p_date_from: dateFrom.toISOString(),
        p_date_to: dateTo.toISOString(),
      })
      if (error) throw error
      return data as DashboardStats
    },
  })
}